import { render, staticRenderFns } from "./menu-quarternary.vue?vue&type=template&id=09fd79c8&scoped=true"
import script from "./menu-quarternary.vue?vue&type=script&lang=js"
export * from "./menu-quarternary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fd79c8",
  null
  
)

export default component.exports